<div class="tele-cmi-case-details">
  <div>
    <p class="case-details-section-header">Insured</p>
    <p>{{ insuredName }}</p>
    <p>Born {{ insuredDOB }}</p>
    <p>SSN (last 4): {{ ssnLast4 }}</p>
  </div>

  <div *ngIf="foreignLanguage">
    <p class="case-details-section-header">Language</p>
    <p>{{ language }}</p>
  </div>

  <div>
    <p class="case-details-section-header">Contact Info</p>
    <p>Preferred method: {{ modeOfContact }}</p>
    <ng-container *ngIf="modeOfContactIsPhone">
      <p>Best time: {{ bestTimeToCall }}</p>
      <p>Location: {{ insuredState }}</p>
    </ng-container>
    <p>{{ insuredPhone }}</p>
    <p>{{ insuredEmail }}</p>
  </div>
</div>
